import { defineStore } from "pinia";
import type { ICart } from "../types/general";

export const useCartStore = defineStore("cart", {
  state: (): { cart?: ICart } => ({
    cart: undefined,
  }),
  getters: {
    getCartItems: (state) => state.cart?.items,
    getCartCount: (state) => state.cart?.items?.length ?? 0,
    getCartId: (state) => state.cart?.uuid,
    getCart: (state) => state.cart,
  },
  actions: {
    setCart(cart?: ICart) {
      this.cart = cart;
      if (window && cart?.uuid) localStorage?.setItem("cartId", cart.uuid);
    },
  },
});
